<!-- Model Content STARTS -->
<div class="modal-content bg-white" style="height: 100vh; overflow-y: auto;">
  <div class="modal-wrapper">
    <!-- Header Start -->
    <div class="modal-header border-0 position-relative">

      <button type="button" class="btn-close me-3" aria-label="Close" (click)="onCancelClick()"></button>
      @if (projDocUpload) {
        <div class="modal-title w-100 border-0 mt-5" id="myModalLabel">
          <small class="grey-muted footer-text">{{userPersistenceService.generalTranslation.UploadDoc}}</small><br>
        </div>
      }
    </div>
    <!-- Header ENDS -->
    <!-- Body Start -->
    <div class="modal-body pt-0">
      <div>
        <ifc-measure-document-comment [projDocUpload]="projDocUpload"></ifc-measure-document-comment>
      </div>
    </div>
    <!-- Body Ends -->
    <!-- Model Content Ends -->
  </div>
</div>
